// extracted by mini-css-extract-plugin
export default {"headercontent":"Header_headercontent__O6T-W","logo":"Header_logo__UsziS","uniName":"Header_uniName__NJ8HE","active":"Header_active__rHuVo","header":"Header_header__HXQOm"};